import uuid from 'powtoon-commons/utils/uuid'
import {
  getManifestObjectsWithLockInfo,
  getSpriteWithLocks,
  slideRequiredLicenseLevelStage,
  slideRequiredLicenseLevelBackground,
  OUTRO_TYPE_FULL,
  WATERMARK_TYPE_NONE,
  WATERMARK_TYPE_REGULAR,
  WATERMARK_TYPE_AI,
  ASPECT_RATIO_SQUARE,
  ENABLE_SQUARE_OUTRO
} from 'powtoon-commons/licensing'
import {isPowtoonFromAiSource} from 'powtoon-document/utils'

export function getOutro(permissions, aspectRatio) {

  const showSquareOutro = (aspectRatio === ASPECT_RATIO_SQUARE) && (permissions.squareOutro === ENABLE_SQUARE_OUTRO)

  if (showSquareOutro) {
    return OUTRO_TYPE_FULL
  }

  return permissions.outro
}

export function getBranding({
  permissions, aspectRatio, watermarkOnExport = null, hideBranding, forceShowBranding, contentSource
}){
  const isAiSource = isPowtoonFromAiSource(contentSource)

  if (hideBranding) {
    return WATERMARK_TYPE_NONE
  }

  if (((aspectRatio === ASPECT_RATIO_SQUARE) && (permissions.squareBranding === ENABLE_SQUARE_OUTRO)) ||
    forceShowBranding) {
    return isAiSource ? WATERMARK_TYPE_AI : WATERMARK_TYPE_REGULAR
  }

  const permissionsWatermark = isAiSource && permissions.waterMark !== WATERMARK_TYPE_NONE
    ? WATERMARK_TYPE_AI
    : permissions.waterMark

  const isWatermarkOnExport = ((permissionsWatermark === WATERMARK_TYPE_NONE) && (watermarkOnExport !== null))
  const exportWatermark = isAiSource && isWatermarkOnExport ? WATERMARK_TYPE_AI : watermarkOnExport
  return isWatermarkOnExport ? exportWatermark : permissionsWatermark
}

let prevManifest = {}
let prevPermissions = {}
let prevSlides = {}
let prevWatermarkOnExport, prevHideBranding, prevAspectRatio = null
let prevPlayerPermissions = null

export const setPrevValues = (
  manifest,
  permissions,
  slides,
  watermarkOnExport,
  hideBranding,
  aspectRatio
) => {
  prevManifest = manifest
  prevPermissions = permissions
  prevSlides = slides
  prevWatermarkOnExport = watermarkOnExport
  prevHideBranding = hideBranding
  prevAspectRatio = aspectRatio
}

export const setPrevPlayerPermissions = value => prevPlayerPermissions = value

export function reCalcPlayerPermissions(document, permissions, watermarkOnExport, hideBranding) {
  const {content: {powtoon: {slides, manifest, exportAspectRatio: {method: aspectRatio}}}} = document
  const permissionsChanged = prevPermissions !== permissions
  const manifestChanged = prevManifest !== manifest
  const slidesChanged = prevSlides !== slides
  const watermarkOnExportChanged = prevWatermarkOnExport !== watermarkOnExport
  const hideBrandingChanged = prevHideBranding !== hideBranding
  const aspectRatioChanged = prevAspectRatio !== aspectRatio
  return permissionsChanged || manifestChanged || slidesChanged ||
  watermarkOnExportChanged || hideBrandingChanged || aspectRatioChanged
}

export function getPlayerPermissions(
  document, permissions, {watermarkOnExport = null, hideBranding = false, enableBrandingWhenDocumentHasLocks = true}
) {
  if (!reCalcPlayerPermissions(document, permissions, watermarkOnExport, hideBranding)){
    return prevPlayerPermissions
  }

  let permissionsVersionID = prevPlayerPermissions && prevPlayerPermissions.permissionsVersionID

  if (prevPermissions !== permissions) {
    permissionsVersionID = uuid()
  }

  const spritesWatermark = {}, slidesWatermark = {}
  const {content: {powtoon: {slides, manifest, exportAspectRatio: {method: aspectRatio}}}, contentSource} = document

  setPrevValues(manifest, permissions, slides, watermarkOnExport, hideBranding, aspectRatio)

  const manifestObjects = manifest || {}
  const manifestObjectsWithLocks = getManifestObjectsWithLockInfo(manifestObjects, permissions)

  slides.forEach(slide => {

    const {tracks, sceneId, id, background, camera} = slide

    if (sceneId || camera) {
      const slideRequiredLicenseLevel = slideRequiredLicenseLevelStage(slide, manifestObjectsWithLocks)
      if (slideRequiredLicenseLevel !== null) {
        slidesWatermark[id] = slideRequiredLicenseLevel
      }
    }
    if (background)
    {
      const {contentItemId} = background
      const licenseLevel = slideRequiredLicenseLevelBackground(slide, manifestObjectsWithLocks)
      if (licenseLevel) {
        spritesWatermark[contentItemId] = licenseLevel
      }
    }
    tracks.forEach(({sprites}) => {

      sprites.forEach(sprite => {
        const {id} = sprite
        const SpriteWithLocks =  getSpriteWithLocks(sprite, manifestObjectsWithLocks, sceneId)
        const {
          isLocked,
          licenseLevel,
          content: {
            isLocked: contentIsLocked,
            licenseLevel: contentLicenseLevel,
            contentItemId
          } = {}
        } = SpriteWithLocks


        if (contentIsLocked) {
          spritesWatermark[contentItemId] = contentLicenseLevel
        }
        if (isLocked){
          spritesWatermark[id] = licenseLevel
        }
      })
    })
  })

  const forceShowBranding = (
    enableBrandingWhenDocumentHasLocks &&
    (Object.keys(slidesWatermark).length || Object.keys(spritesWatermark).length)
  )

  const result = {
    timestamp: Date.now(),
    spritesWatermark,
    slidesWatermark,
    branding: getBranding({
      permissions, aspectRatio, watermarkOnExport, hideBranding, forceShowBranding, contentSource
    }),
    outro: getOutro(permissions, aspectRatio),
    permissionsVersionID
  }
  setPrevPlayerPermissions(result)
  return result
}


